// frontend/packages/business-console/src/services/geoService.js
//
// 5.6 follow-up — Console-side wrapper around the backend
// `POST /api/v2/geo/reverse-geocode` route. Used by the GeoTag
// renderer to stamp a human-readable address after capturing a
// geolocation fix. Server-side keeps the Google Maps API key off
// the browser and emits per-tenant ApiUsageEvent rows for billing.

import { api } from '@upryzze/services';

/**
 * Reverse-geocode coordinates to a formatted address. Never throws —
 * callers should treat any falsy `address` in the response the same
 * way as a network failure (leave `value.address` null and continue).
 *
 * @param {number} lat
 * @param {number} lng
 * @returns {Promise<{ address: string|null, source: 'google'|'unavailable' }>}
 */
export async function reverseGeocode(lat, lng) {
  try {
    const { data } = await api.post('/v2/geo/reverse-geocode', { lat, lng });
    return {
      address: typeof data?.address === 'string' ? data.address : null,
      source: data?.source === 'google' ? 'google' : 'unavailable',
    };
  } catch {
    return { address: null, source: 'unavailable' };
  }
}
